<div class="mat-dialog-container h-full flex flex-col bg-white dark:bg-slate-900 rounded-lg shadow-xl overflow-hidden">
   <!-- Header -->
   <div #head class="shrink-0 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-slate-800">
      <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state"
         (onOkClick)="doOk($event)"
         (onEditAndSaveClick)="doEditAndSave($event)" (onCancelClick)="doCancel($event)">
      </app-modal-header>
   </div>

   <!-- Scrollable Content -->
   <div class="jk-content overflow-y-auto p-6">
      <div class="grid grid-cols-1 md:grid-cols-12 gap-6">

         <!-- Section: Basic Information -->
         <div class="md:col-span-6">
            <app-jkedit label="標題" [emojiLabel]="'🏷️'" #TitleCom id="Title" [(value)]="item.Title" placeholder="請輸入標題"
               [readonly]="isBrowse" [required]="true" class="w-full">
            </app-jkedit>
         </div>
         <div class="md:col-span-6">
            <app-jkedit label="備註" [emojiLabel]="'✏️'" #PSCom id="PS" [(value)]="item.PS" placeholder="請輸入備註"
               [readonly]="isBrowse" class="w-full">
            </app-jkedit>
         </div>

         <!-- Section: SQL & Logic -->
         <div class="md:col-span-6">
            <app-jktextarea height="200px" label="SQL Select" #SQLSelectCom id="SQLSelect" [(value)]="item.SQLSelect"
               [required]="true" placeholder="SELECT ..." [readonly]="isBrowse" class="w-full font-mono text-sm">
            </app-jktextarea>
         </div>
         <div class="md:col-span-6">
            <app-jktextarea height="180px" label="顯示設定 (Display)" [emojiLabel]="'📝'" #DisplayCom id="Display"
               [(value)]="item.Display" [required]="true" placeholder="設定顯示格式..." [readonly]="isBrowse" class="w-full">
            </app-jktextarea>
            <button class="btn-editAndSave" (click)="srv.setDisplay(item.SQLSelect,item,cdr)">
               產生欄位格式
            </button>
         </div>
         <div class="md:col-span-6">
            <div class="flex flex-col relative h-full">
               <div class="flex justify-between items-center mb-1">
                  <!-- Label handled by component usually, but adding absolute button for alignment -->
               </div>
               <app-jktextarea height="150px" label="WHERE 參數設定 (MAP)" [emojiLabel]="'🛠️'" #MAPCom id="MAP"
                  [(value)]="item.MAP" [required]="true" placeholder="Map Params..." [readonly]="isBrowse"
                  class="w-full font-mono text-sm">
               </app-jktextarea>
               <button (click)="openMapEditor()" class="btn-edit" [disabled]="isBrowse" class="btn btn-editAndSave " label="編輯參數">
                  ✏️ 編輯參數
               </button>
            </div>
         </div>

         <div class="md:col-span-6">
            <app-jktextarea height="150px" label="欄位排序(格式(多行):欄位1 ASC/DESC,欄位2 ASC/DESC,...;中文顯示名稱)" #SQLOrderCom
               id="SQLOrder" [(value)]="item.SQLOrder" placeholder="格式:欄位1 ASC/DESC,欄位2 ASC/DESC,...;中文顯示名稱"
               [readonly]="isBrowse" class="w-full font-mono text-sm">
            </app-jktextarea>
         </div>
         <div class="md:col-span-6">
            <app-jktextarea height="200px" label="SQL Where" #SQLWhereCom id="SQLWhere" [(value)]="item.SQLWhere"
               placeholder="WHERE ..." [readonly]="isBrowse" class="w-full font-mono text-sm">
            </app-jktextarea>
         </div>
         <div class="md:col-span-6">
            <app-jkedit label="使用者權限設定" #CreateUserIDCom id="CreateUserID" [(value)]="item.CreateUserID"
               placeholder="逗號分開" [readonly]="isBrowse" class="w-full opacity-75">
            </app-jkedit>
         </div>

         <!-- Section: Data Definition -->
         <div
            class="md:col-span-12 grid grid-cols-1 md:grid-cols-3 gap-6 p-4 bg-gray-50 dark:bg-slate-800/50 rounded-lg border border-gray-100 dark:border-gray-700">
            <div>
               <app-jkedit label="主資料表..." #MainTableCom id="MainTable" [(value)]="item.MainTable" [required]="true"
                  placeholder="Main Table" [readonly]="srv.isPvi" class="w-full">
               </app-jkedit>
            </div>

            <div class="flex items-end gap-2">
               <div class="flex">
                  <app-jkedit label="序號" #ITEMCom id="ITEM" [(value)]="item.ITEM" [required]="true"
                     placeholder="Item No." [readonly]="true" class="w-full">
                  </app-jkedit>
               </div>
               <button [disabled]="true"
                  class="btn-editAndSave px-3 h-10 shadow-sm bg-indigo-500 hover:bg-indigo-600 text-white rounded transition-colors"
                  (click)="geneItemNo()" label="自動產生序號">
                  產生序號
               </button>
            </div>

            <div>
               <app-jkedit label="類別" #TYPECom id="TYPE" [(value)]="item.TYPE" [required]="true" placeholder="Type"
                  [readonly]="isBrowse" class="w-full">
               </app-jkedit>
            </div>
         </div>
         <!-- Section: Audit Info -->
         <div
            class="md:col-span-12 grid grid-cols-1 md:grid-cols-3 gap-6 pt-4 border-t border-gray-100 dark:border-gray-800">
            <app-jkdatefield label="建立日期" #CreateDateCom id="CreateDate" [(date)]="item.CreateDate"
               placeholder="YYYY/MM/DD" [readonly]="isBrowse" class="w-full opacity-75">
            </app-jkdatefield>
            <app-jkdatefield label="修改日期" #ModiDateCom id="ModiDate" [(date)]="item.ModiDate" placeholder="YYYY/MM/DD"
               [readonly]="isBrowse" class="w-full opacity-75">
            </app-jkdatefield>
         </div>

      </div>
   </div>
</div>
